import { MBLVIEW } from '../actionTypes';

export const getMobileView = (action) => ({
  type: MBLVIEW.FETCH,
  payload: action.payload,
});
